import { useEffect } from 'react';

import useSocialProfileTransition from '@/utils/hooks/socialprofiles/useSocialProfileTransition';
//hooks
import useAnalytics from '@/utils/hooks/swr/useAnalytics';
import useSocialProfilePermissions from '@/utils/hooks/swr/useSocialProfilePermissions';

import AnalyticsErrorBanner from '@/components/composite/Analyze/AnalyticsErrorBanner';
// Component
import { RenderAnalyticsItem } from '@/components/pages/analyze/RenderAnalyticsItem';

export const StatsWrapper = ({
    activeSocialProfile,
    periodStart,
    periodEnd,
    period,
    compareTo,
    pageConfig,
    albumId = null,
    album = null,
    updateStats,
    swrOptions = {},
    setUpdateStats = () => {
        /** */
    }
}) => {
    const { transitionInProgress } = useSocialProfileTransition();

    const { permissions, isLoading: isLoadingPermission } = useSocialProfilePermissions(
        activeSocialProfile?.id
    );
    const {
        config: statConfig,
        fields,
        parameters,
        waitForSPTransition
    } = pageConfig(activeSocialProfile?.social_network_type, {
        postTypes: album?.criteria?.post_types,
        albumType: album?.criteria?.album_type
    });

    const {
        analytics,
        dates,
        mutateAnalytics,
        analyticsError,
        setRequestParams,
        isValidatingAnalytics,
        setState,
        isLoading: isLoadingAnalytics
    } = useAnalytics(
        activeSocialProfile?.id,
        {
            period,
            comparison_period: compareTo,
            start: periodStart,
            end: periodEnd,
            album_id: albumId,
            parameters,
            fields
        },
        { revalidateOnFocus: false, revalidateOnReconnect: false, ...swrOptions }
    );

    useEffect(() => {
        if (updateStats) {
            if (!isLoadingAnalytics) {
                setState(null);
                mutateAnalytics(null);
            }
            setUpdateStats(false);
        }
    }, [updateStats]);

    return (
        <>
            <AnalyticsErrorBanner
                analyticsError={analyticsError}
                mutateAnalytics={mutateAnalytics}
            />
            {statConfig &&
                statConfig.map((config) => (
                    <RenderAnalyticsItem
                        key={config.id}
                        config={{ ...config, permissions }}
                        albumId={albumId}
                        analytics={analytics}
                        dates={dates}
                        reloadStats={updateStats}
                        network={activeSocialProfile?.social_network_type}
                        period={{ period, periodStart, periodEnd, compareTo }}
                        analyticsState={{
                            mutateAnalytics,
                            isLoadingAnalytics:
                                isLoadingAnalytics || (transitionInProgress && waitForSPTransition),
                            isLoadingPermission,
                            setRequestParams,
                            isValidatingAnalytics,
                            setState
                        }}
                    />
                ))}
        </>
    );
};
